<template>
    <div>
        <MenuAccount/>
        <RemainingAssetReportList/>
    </div>
</template>

<script>

import MenuAccount from '@/components/menuadmin/account/accountheader/MenuAccount.vue'
import RemainingAssetReportList from '@/components/menuadmin/account/accountreport/RemainingAssetReportList.vue'
export default {
    name:'remainingAssetReport',
    components:{
        MenuAccount,
        RemainingAssetReportList,
    },
}
</script>